export const SET_PROMO = 'SET_PROMO';

export const setPromo = (faq) => {
  return {
    type: SET_PROMO,
    payload: faq,
  };
};
